import React from "react";

const ResumeSummary = ({ resume }) => {
  return (
    <div className="card z-depth-0 project-summary">
      <div className="card-content grey-text text-darken-3">
        <span className="card-title">{resume.title}</span>
        <p>Career Objectives: {resume.careerObjectives}</p>
      </div>
    </div>
  );
};

export default ResumeSummary;